// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  font-family: "Roboto";
  font-weight: normal;
}

/* 3. header style */
.header-area {
  position: relative;
}
.header-large-device {
  background-color: #27282B;
}
.header-top form.dropdown #cars {
  max-width: 36px;
  background-color: transparent;
  border-color: #fff;
  color: #fff;
  font-size: 16px;
  border-width: 2px;
  font-family: 'Montserrat', sans-serif;
}
.header-top form.dropdown #cars option {
  color: #000;
}
.header-area .header-bottom {
  position: relative;
}
.header-bottom .main-menu {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 18px 0;
}
.search-box {
  position: relative;
  padding-right: 30px;
}
.search-box .searchicon {
  font-size: 18px;
  position: absolute;
  top: 50%;
  color: #fff;
  left: 16px;
  transform: translateY(-50%);
}
.search-box .extand {
  width: 100%;
  cursor: pointer;
  font-family: 'Roboto';
  font-size: 16px;
  line-height: 28px;
  padding: 7px 39px;
  color: #fff;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid #FFFFFF;
  border-radius: 10px;
  transition: all 0.4s ease-in-out;
  outline: 0;
}
.main-menu a.btn-pricing {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 28px;
  color: #fff;
  cursor: pointer;
  padding-right: 30px;
}
.main-menu a.btn-pricing:hover {
  color: #1DB100;
}
.main-menu .button {
  position: relative;
  display: inline-block;
  padding: 9px 32px;
  text-align: center;
  z-index: 2;
  color: #fff;
  font-family: 'Roboto';
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  border-radius: 25px;
  background-color: #1DB100;
  border: 1px solid #1DB100;
  transition: all .4s;
}
.main-menu .button:hover {
  border: 1px solid #fff;
  background-color: transparent;
}
.main-menu .button.btn-p {
  margin-right: 20px;
  background-color: transparent;
  border: 1px solid #fff;
}

/* 2. container style */
@media (min-width: 1140px) {
  .container {
      max-width: 1440px;
  }
}

/* media query */
@media (max-width: 1366px){
  h1 {
      font-size: 60px;
      line-height: 70px;
  }
  h2 {
      font-size: 20px;
      line-height: 30px;
  }
  .hero-slider .slider-content h1 {
      padding-bottom: 10px;
  }
  .hero-slider {
      height: 600px;
      padding-bottom: 60px;
  }
  .bard-logo-area {
      position: relative;
      padding: 80px 0 20px;
  }
  .information-title {
      font-size: 60px;
      line-height: 70px;
      padding-bottom: 20px;
  }
  .information-wrapper h2 {
      font-size: 40px;
      line-height: 50px;
      padding-bottom: 50px;
      width: 100%;
  }
  .banner-area {
      padding-bottom: 50px;
      height: 600px;
  }
  .banner-content h1 {
      font-size: 50px;
      line-height: 60px;
  }
  .section-title {
      padding: 80px 0 30px;
  }
  .user-experiences-bottom h2, .user-experiences-top h2 {
      font-size: 60px;
      line-height: 70px;
      padding-bottom: 10px;
      width: 100%;
  }
  .user-experiences-bottom h3, .user-experiences-top h3 {
      font-size: 24px;
      line-height: 34px;
  }
  .user-experiences-area {
      padding-bottom: 80px;
  }
  .video-section-content h2 {
      font-size: 60px;
      line-height: 70px;
      padding-bottom: 20px
  }
  .video-section-content h3 {
      font-size: 40px;
      line-height: 50px;
  }
  .video-section {
      position: relative;
      padding-bottom: 80px;
  }
  .footer-area:last-child {
      padding-top: 80px;
      padding-bottom: 80px;
  }
}
@media (max-width: 1024px) {
  h1 {
      font-size: 50px;
      line-height: 60px;
  }
  .main-menu .button {
      padding: 9px 26px;
  }
  .hero-slider {
      height: 450px;
      padding-bottom: 50px;
  }
  .information-title {
      font-size: 50px;
      line-height: 60px;
      padding-bottom: 15px;
  }
  .banner-content h1 {
      font-size: 40px;
      line-height: 50px;
  }
  .user-experiences-bottom h2, .user-experiences-top h2 {
      font-size: 50px;
      line-height: 60px;
  }
  .user-experiences-bottom h3, .user-experiences-top h3 {
      font-size: 20px;
      line-height: 30px;
  }
  .video-section-content h2 {
      font-size: 50px;
      line-height: 60px;
      padding-bottom: 15px;
  }
}
@media (max-width: 768px) {
  .search-box {
      padding-right: 15px;
  }
  .main-menu a.btn-pricing {
      padding-right: 15px;
  }
  .main-menu .button.btn-p {
      margin-right: 15px;
  }
  h1 {
      font-size: 40px;
      line-height: 50px;
  }
  .main-menu .button {
      padding: 9px 6px;
  }
  .main-menu .button {
      font-size: 10px;
      line-height: 20px;
      font-weight: 400;
      border-radius: 5px;
  }
  .bard-logo-area {
      padding: 60px 0 20px;
  }
  .bard-logo-title h3 {
      font-size: 24px;
      line-height: 34px;
  }
  .bard-logo-title {
      padding-bottom: 40px;
  }
  .bard-logo-content {
      padding-left: 50px;
      padding-right: 50px;
  }
  .border-bottom {
      padding-bottom: 30px;
  }
  .bard-logo-area .title {
      padding-bottom: 40px;
  }
  .information-title {
      font-size: 40px;
      line-height: 50px;
      padding-bottom: 10px;
  }
  .information-wrapper h2 {
      font-size: 30px;
      line-height: 40px;
      padding-bottom: 40px;
  }
  .banner-content h1 {
      font-size: 30px;
      line-height: 40px;
  }
  .banner-area {
      padding-bottom: 40px;
      height: 450px;
  }
  .section-title {
      padding: 60px 0 15px;
  }
  .user-experiences-bottom h2, .user-experiences-top h2 {
      font-size: 26px;
      line-height: 36px;
  }
  .user-experiences-bottom h3, .user-experiences-top h3 {
      font-size: 14px;
      line-height: 18px;
      padding: 0 20px 20px;
  }
  .user-experiences-top {
      padding-top: 20px;
  }
  .user-experiences-area {
      padding-bottom: 60px;
  }
  .video-section-content h2 {
      font-size: 40px;
      line-height: 50px;
      padding-bottom: 15px;
  }
  .video-section-content h3 {
      font-size: 30px;
      line-height: 40px;
  }
  .video-section {
      position: relative;
      padding-bottom: 60px;
  }
  .footer-area:last-child {
      padding-top: 60px;
      padding-bottom: 60px;
  }
}
@media (max-width: 767px) {
  h1 {
      font-size: 28px;
      line-height: 38px;
  }
  h2 {
      font-size: 18px;
      line-height: 24px;
  }
  .header-bottom .main-menu {
      display: block;
      text-align: center;
  }
  .header-bottom .logo {
      text-align: center;
      padding-top: 10px;
  }
  .main-menu .button  {
      margin-top: 10px;
  }
  .main-menu .button {
      padding: 9px 20px;
      font-size: 14px;
  }
  
}

/*WC 06162022*/
@media (max-width: 844px) {
    h1 {
        font-size: 50px;
        line-height: 60px;
    }
    .main-menu .button.btn-p {
        margin-right: 20px;
        background-color: transparent;
        border: 1px solid #fff;
    }
    .main-menu .button  {
        margin-top: 10px;

    }
}
/*WC 06162022*/`, "",{"version":3,"sources":["webpack://./src/app/layout/header/header.component.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,qCAAqC;AACvC;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;EAEnB,gCAAgC;EAChC,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE;MACI,iBAAiB;EACrB;AACF;;AAEA,gBAAgB;AAChB;EACE;MACI,eAAe;MACf,iBAAiB;EACrB;EACA;MACI,eAAe;MACf,iBAAiB;EACrB;EACA;MACI,oBAAoB;EACxB;EACA;MACI,aAAa;MACb,oBAAoB;EACxB;EACA;MACI,kBAAkB;MAClB,oBAAoB;EACxB;EACA;MACI,eAAe;MACf,iBAAiB;MACjB,oBAAoB;EACxB;EACA;MACI,eAAe;MACf,iBAAiB;MACjB,oBAAoB;MACpB,WAAW;EACf;EACA;MACI,oBAAoB;MACpB,aAAa;EACjB;EACA;MACI,eAAe;MACf,iBAAiB;EACrB;EACA;MACI,oBAAoB;EACxB;EACA;MACI,eAAe;MACf,iBAAiB;MACjB,oBAAoB;MACpB,WAAW;EACf;EACA;MACI,eAAe;MACf,iBAAiB;EACrB;EACA;MACI,oBAAoB;EACxB;EACA;MACI,eAAe;MACf,iBAAiB;MACjB;EACJ;EACA;MACI,eAAe;MACf,iBAAiB;EACrB;EACA;MACI,kBAAkB;MAClB,oBAAoB;EACxB;EACA;MACI,iBAAiB;MACjB,oBAAoB;EACxB;AACF;AACA;EACE;MACI,eAAe;MACf,iBAAiB;EACrB;EACA;MACI,iBAAiB;EACrB;EACA;MACI,aAAa;MACb,oBAAoB;EACxB;EACA;MACI,eAAe;MACf,iBAAiB;MACjB,oBAAoB;EACxB;EACA;MACI,eAAe;MACf,iBAAiB;EACrB;EACA;MACI,eAAe;MACf,iBAAiB;EACrB;EACA;MACI,eAAe;MACf,iBAAiB;EACrB;EACA;MACI,eAAe;MACf,iBAAiB;MACjB,oBAAoB;EACxB;AACF;AACA;EACE;MACI,mBAAmB;EACvB;EACA;MACI,mBAAmB;EACvB;EACA;MACI,kBAAkB;EACtB;EACA;MACI,eAAe;MACf,iBAAiB;EACrB;EACA;MACI,gBAAgB;EACpB;EACA;MACI,eAAe;MACf,iBAAiB;MACjB,gBAAgB;MAChB,kBAAkB;EACtB;EACA;MACI,oBAAoB;EACxB;EACA;MACI,eAAe;MACf,iBAAiB;EACrB;EACA;MACI,oBAAoB;EACxB;EACA;MACI,kBAAkB;MAClB,mBAAmB;EACvB;EACA;MACI,oBAAoB;EACxB;EACA;MACI,oBAAoB;EACxB;EACA;MACI,eAAe;MACf,iBAAiB;MACjB,oBAAoB;EACxB;EACA;MACI,eAAe;MACf,iBAAiB;MACjB,oBAAoB;EACxB;EACA;MACI,eAAe;MACf,iBAAiB;EACrB;EACA;MACI,oBAAoB;MACpB,aAAa;EACjB;EACA;MACI,oBAAoB;EACxB;EACA;MACI,eAAe;MACf,iBAAiB;EACrB;EACA;MACI,eAAe;MACf,iBAAiB;MACjB,oBAAoB;EACxB;EACA;MACI,iBAAiB;EACrB;EACA;MACI,oBAAoB;EACxB;EACA;MACI,eAAe;MACf,iBAAiB;MACjB,oBAAoB;EACxB;EACA;MACI,eAAe;MACf,iBAAiB;EACrB;EACA;MACI,kBAAkB;MAClB,oBAAoB;EACxB;EACA;MACI,iBAAiB;MACjB,oBAAoB;EACxB;AACF;AACA;EACE;MACI,eAAe;MACf,iBAAiB;EACrB;EACA;MACI,eAAe;MACf,iBAAiB;EACrB;EACA;MACI,cAAc;MACd,kBAAkB;EACtB;EACA;MACI,kBAAkB;MAClB,iBAAiB;EACrB;EACA;MACI,gBAAgB;EACpB;EACA;MACI,iBAAiB;MACjB,eAAe;EACnB;;AAEF;;AAEA,cAAc;AACd;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,kBAAkB;QAClB,6BAA6B;QAC7B,sBAAsB;IAC1B;IACA;QACI,gBAAgB;;IAEpB;AACJ;AACA,cAAc","sourcesContent":[":host {\n  font-family: \"Roboto\";\n  font-weight: normal;\n}\n\n/* 3. header style */\n.header-area {\n  position: relative;\n}\n.header-large-device {\n  background-color: #27282B;\n}\n.header-top form.dropdown #cars {\n  max-width: 36px;\n  background-color: transparent;\n  border-color: #fff;\n  color: #fff;\n  font-size: 16px;\n  border-width: 2px;\n  font-family: 'Montserrat', sans-serif;\n}\n.header-top form.dropdown #cars option {\n  color: #000;\n}\n.header-area .header-bottom {\n  position: relative;\n}\n.header-bottom .main-menu {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 18px 0;\n}\n.search-box {\n  position: relative;\n  padding-right: 30px;\n}\n.search-box .searchicon {\n  font-size: 18px;\n  position: absolute;\n  top: 50%;\n  color: #fff;\n  left: 16px;\n  transform: translateY(-50%);\n}\n.search-box .extand {\n  width: 100%;\n  cursor: pointer;\n  font-family: 'Roboto';\n  font-size: 16px;\n  line-height: 28px;\n  padding: 7px 39px;\n  color: #fff;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid #FFFFFF;\n  border-radius: 10px;\n  -webkit-transition: all 0.4s ease-in-out;\n  transition: all 0.4s ease-in-out;\n  outline: 0;\n}\n.main-menu a.btn-pricing {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 28px;\n  color: #fff;\n  cursor: pointer;\n  padding-right: 30px;\n}\n.main-menu a.btn-pricing:hover {\n  color: #1DB100;\n}\n.main-menu .button {\n  position: relative;\n  display: inline-block;\n  padding: 9px 32px;\n  text-align: center;\n  z-index: 2;\n  color: #fff;\n  font-family: 'Roboto';\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 600;\n  border-radius: 25px;\n  background-color: #1DB100;\n  border: 1px solid #1DB100;\n  transition: all .4s;\n}\n.main-menu .button:hover {\n  border: 1px solid #fff;\n  background-color: transparent;\n}\n.main-menu .button.btn-p {\n  margin-right: 20px;\n  background-color: transparent;\n  border: 1px solid #fff;\n}\n\n/* 2. container style */\n@media (min-width: 1140px) {\n  .container {\n      max-width: 1440px;\n  }\n}\n\n/* media query */\n@media (max-width: 1366px){\n  h1 {\n      font-size: 60px;\n      line-height: 70px;\n  }\n  h2 {\n      font-size: 20px;\n      line-height: 30px;\n  }\n  .hero-slider .slider-content h1 {\n      padding-bottom: 10px;\n  }\n  .hero-slider {\n      height: 600px;\n      padding-bottom: 60px;\n  }\n  .bard-logo-area {\n      position: relative;\n      padding: 80px 0 20px;\n  }\n  .information-title {\n      font-size: 60px;\n      line-height: 70px;\n      padding-bottom: 20px;\n  }\n  .information-wrapper h2 {\n      font-size: 40px;\n      line-height: 50px;\n      padding-bottom: 50px;\n      width: 100%;\n  }\n  .banner-area {\n      padding-bottom: 50px;\n      height: 600px;\n  }\n  .banner-content h1 {\n      font-size: 50px;\n      line-height: 60px;\n  }\n  .section-title {\n      padding: 80px 0 30px;\n  }\n  .user-experiences-bottom h2, .user-experiences-top h2 {\n      font-size: 60px;\n      line-height: 70px;\n      padding-bottom: 10px;\n      width: 100%;\n  }\n  .user-experiences-bottom h3, .user-experiences-top h3 {\n      font-size: 24px;\n      line-height: 34px;\n  }\n  .user-experiences-area {\n      padding-bottom: 80px;\n  }\n  .video-section-content h2 {\n      font-size: 60px;\n      line-height: 70px;\n      padding-bottom: 20px\n  }\n  .video-section-content h3 {\n      font-size: 40px;\n      line-height: 50px;\n  }\n  .video-section {\n      position: relative;\n      padding-bottom: 80px;\n  }\n  .footer-area:last-child {\n      padding-top: 80px;\n      padding-bottom: 80px;\n  }\n}\n@media (max-width: 1024px) {\n  h1 {\n      font-size: 50px;\n      line-height: 60px;\n  }\n  .main-menu .button {\n      padding: 9px 26px;\n  }\n  .hero-slider {\n      height: 450px;\n      padding-bottom: 50px;\n  }\n  .information-title {\n      font-size: 50px;\n      line-height: 60px;\n      padding-bottom: 15px;\n  }\n  .banner-content h1 {\n      font-size: 40px;\n      line-height: 50px;\n  }\n  .user-experiences-bottom h2, .user-experiences-top h2 {\n      font-size: 50px;\n      line-height: 60px;\n  }\n  .user-experiences-bottom h3, .user-experiences-top h3 {\n      font-size: 20px;\n      line-height: 30px;\n  }\n  .video-section-content h2 {\n      font-size: 50px;\n      line-height: 60px;\n      padding-bottom: 15px;\n  }\n}\n@media (max-width: 768px) {\n  .search-box {\n      padding-right: 15px;\n  }\n  .main-menu a.btn-pricing {\n      padding-right: 15px;\n  }\n  .main-menu .button.btn-p {\n      margin-right: 15px;\n  }\n  h1 {\n      font-size: 40px;\n      line-height: 50px;\n  }\n  .main-menu .button {\n      padding: 9px 6px;\n  }\n  .main-menu .button {\n      font-size: 10px;\n      line-height: 20px;\n      font-weight: 400;\n      border-radius: 5px;\n  }\n  .bard-logo-area {\n      padding: 60px 0 20px;\n  }\n  .bard-logo-title h3 {\n      font-size: 24px;\n      line-height: 34px;\n  }\n  .bard-logo-title {\n      padding-bottom: 40px;\n  }\n  .bard-logo-content {\n      padding-left: 50px;\n      padding-right: 50px;\n  }\n  .border-bottom {\n      padding-bottom: 30px;\n  }\n  .bard-logo-area .title {\n      padding-bottom: 40px;\n  }\n  .information-title {\n      font-size: 40px;\n      line-height: 50px;\n      padding-bottom: 10px;\n  }\n  .information-wrapper h2 {\n      font-size: 30px;\n      line-height: 40px;\n      padding-bottom: 40px;\n  }\n  .banner-content h1 {\n      font-size: 30px;\n      line-height: 40px;\n  }\n  .banner-area {\n      padding-bottom: 40px;\n      height: 450px;\n  }\n  .section-title {\n      padding: 60px 0 15px;\n  }\n  .user-experiences-bottom h2, .user-experiences-top h2 {\n      font-size: 26px;\n      line-height: 36px;\n  }\n  .user-experiences-bottom h3, .user-experiences-top h3 {\n      font-size: 14px;\n      line-height: 18px;\n      padding: 0 20px 20px;\n  }\n  .user-experiences-top {\n      padding-top: 20px;\n  }\n  .user-experiences-area {\n      padding-bottom: 60px;\n  }\n  .video-section-content h2 {\n      font-size: 40px;\n      line-height: 50px;\n      padding-bottom: 15px;\n  }\n  .video-section-content h3 {\n      font-size: 30px;\n      line-height: 40px;\n  }\n  .video-section {\n      position: relative;\n      padding-bottom: 60px;\n  }\n  .footer-area:last-child {\n      padding-top: 60px;\n      padding-bottom: 60px;\n  }\n}\n@media (max-width: 767px) {\n  h1 {\n      font-size: 28px;\n      line-height: 38px;\n  }\n  h2 {\n      font-size: 18px;\n      line-height: 24px;\n  }\n  .header-bottom .main-menu {\n      display: block;\n      text-align: center;\n  }\n  .header-bottom .logo {\n      text-align: center;\n      padding-top: 10px;\n  }\n  .main-menu .button  {\n      margin-top: 10px;\n  }\n  .main-menu .button {\n      padding: 9px 20px;\n      font-size: 14px;\n  }\n  \n}\n\n/*WC 06162022*/\n@media (max-width: 844px) {\n    h1 {\n        font-size: 50px;\n        line-height: 60px;\n    }\n    .main-menu .button.btn-p {\n        margin-right: 20px;\n        background-color: transparent;\n        border: 1px solid #fff;\n    }\n    .main-menu .button  {\n        margin-top: 10px;\n\n    }\n}\n/*WC 06162022*/"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
